import React from 'react';
import { Typography } from '@material-ui/core';
import * as pkg from '../../package.json';

const Footer = () => {
	return (
		<div style={{ position: 'relative', bottom: 0, color: 'gray', width: '100%' }}>
			<Typography align="center">© random flight generator - made with ♥ by VicioGu - {pkg.version}</Typography>
			<Typography align="center">For flight simulators use ONLY!</Typography>
		</div>
	);
};

export default Footer;
